import { render, staticRenderFns } from "./pickupList.vue?vue&type=template&id=54c377ae&scoped=true&"
import script from "./pickupList.js?vue&type=script&lang=js&"
export * from "./pickupList.js?vue&type=script&lang=js&"
import style1 from "./pickupList.vue?vue&type=style&index=1&id=54c377ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c377ae",
  null
  
)

export default component.exports